import React, { useEffect, useRef, useState } from "react";
import { FaDownload } from "react-icons/fa";
import Images from "../assets/Image";
import FilePdf from "../broucherPdf/filePdf";

export default function MostlyViewed() {
  const mostlyViewRef = useRef(null);
  const [mostlyViewVisible, setMostlyViewVisible] = useState(false);

  const mostlyViewedProducts = [
    {
      productImg: Images?.sqCopilot1281,
      label: "USP COPILOT 128 & 256",
      navigatePage: "/product/copilot128-256",
      downloadPdf: FilePdf.usp_COPILOt_128_256,
      fileName: "USP COPILOT 128-256.pdf",
    },
    {
      productImg: Images?.USPJEtSTREAM2,
      label: "USP JETSTREAM II",
      navigatePage: "/product/uspJetStream2",
      downloadPdf: FilePdf.usp_JETSTREAM_II,
      fileName: "USP JETSTREAM II.pdf",
    },
    {
      productImg: Images?.UspA2120,
      label: "USP A-2120",
      navigatePage: "/product/uspA2120",
      downloadPdf: FilePdf.usp_a2120,
      fileName: "USP A-2120.pdf",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setMostlyViewVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (mostlyViewRef.current) {
      observer.observe(mostlyViewRef.current);
    }

    return () => observer.disconnect();
  }, []);
  return (
    <div className="mostlyViewMainContainer">
      <header className="printerDetailsHeader">Mostly Viewed</header>
      <div className="mostlyViewedProductsContainer" ref={mostlyViewRef}>
        {mostlyViewedProducts.map((productDetail, index) => (
          <div
            key={index}
            //  className="mostlyViewedProductContainer"
            className={`mostlyViewedProductContainer ${
              mostlyViewVisible ? "animated" : ""
            }`}
            style={{
              animationDelay: mostlyViewVisible ? `${index * 0.2}s` : "0s",
            }}
          >
            {/* Black overlay container */}
            <div className="mostlyViewedProductOverlayContainer">
              <div className="mostlyViewedProductImageContainer">
                <img
                  className="w-[70%]"
                  src={productDetail.productImg}
                  style={{ objectFit: "contain" }}
                  alt=""
                />
              </div>
              <div className="imageButtons">
                <button
                  className="viewMoreBtn"
                  onClick={() => {
                    window.location.href = productDetail.navigatePage;
                  }}
                >
                  View More
                </button>

                <a
                  href={productDetail.downloadPdf}
                  download={productDetail.fileName}
                >
                  <button className="mostlyViewedDownloadBtn">
                    <FaDownload />
                  </button>
                </a>
              </div>
              <div className="mostlyViewedProductName">
                {productDetail.label}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
